const ADD_TEST_CASES = 'ADD_TEST_CASES';

const ACTION_TYPES = {
  ADD_TEST_CASES,
};

export default ACTION_TYPES;
